import React from 'react';
import StatusBadge from '../common/StatusBadge';
import { Check, X, Trash2, Star } from 'lucide-react';
import { formatDateMoscow } from '../../utils/dateUtils';

const ReviewsTable = ({ reviews, onModerate, onDelete, loading }) => {
    const getRatingStars = (rating) => {
        return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-x-auto hidden md:block">
            <table className="min-w-full divide-y divide-slate-200">
                <thead className="bg-slate-50">
                    <tr>
                        <th className="w-12 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">ID</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Пользователь</th>
                        <th className="w-24 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Оценка</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Текст</th>
                        <th className="w-24 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Статус</th>
                        <th className="w-24 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Тип</th>
                        <th className="w-32 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Дата</th>
                        <th className="w-20 px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Действие</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-slate-200">
                    {reviews.map((review) => (
                        <tr key={review.id} className="hover:bg-slate-50 transition-colors">
                            <td className="px-3 py-3 whitespace-nowrap text-sm font-medium text-indigo-600">{review.id}</td>
                            <td className="px-3 py-3 text-sm text-slate-700 max-w-[150px] break-words">
                                {review.user_fio || review.user_username || 'Неизвестно'}
                                {review.user_username && (
                                    <span className="text-slate-400 ml-1">@{review.user_username}</span>
                                )}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-sm text-slate-700">
                                <div className="flex items-center gap-1">
                                    <span className="text-yellow-500">{getRatingStars(review.rating)}</span>
                                    <span className="text-slate-500 ml-1">({review.rating}/5)</span>
                                </div>
                            </td>
                            <td className="px-3 py-3 text-sm text-slate-700 max-w-[250px] break-words">
                                <div>{review.text}</div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap">
                                <StatusBadge status={review.status} />
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap">
                                {review.is_admin ? (
                                    <span className="px-2 py-1 text-xs font-medium bg-purple-100 text-purple-800 rounded-full">Админ</span>
                                ) : (
                                    <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">Пользователь</span>
                                )}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-sm text-slate-500">
                                {formatDateMoscow(review.created_at)}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-sm font-medium">
                                <div className="flex items-center gap-2">
                                    {review.status === 'pending' && (
                                        <>
                                            <button
                                                onClick={() => onModerate(review.id, 'approved')}
                                                className="text-green-600 hover:text-green-800 p-1 rounded hover:bg-green-50"
                                                title="Одобрить"
                                            >
                                                <Check size={18} />
                                            </button>
                                            <button
                                                onClick={() => onModerate(review.id, 'rejected')}
                                                className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                                                title="Отклонить"
                                            >
                                                <X size={18} />
                                            </button>
                                        </>
                                    )}
                                    <button
                                        onClick={() => onDelete(review.id)}
                                        className="text-slate-400 hover:text-red-600 p-1 rounded hover:bg-red-50"
                                        title="Удалить"
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {reviews.length === 0 && !loading && (
                <div className="p-8 text-center text-slate-500">Отзывы не найдены</div>
            )}
        </div>
    );
};

export default ReviewsTable;
